import React, { useCallback, useEffect, useMemo, useState } from 'react'
import BillingService from '../../services/billing/BillingService'
import { formatDateTimeLocalDate, formatRupiah } from '../../utilities/Utils'
import { Button, Col, Form, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import Card from '../../components/Card'
import DataTable from 'react-data-table-component'
import ExpandableComponentBilling from './expand/ExpandableComponentBilling'
import { FaDownload, FaMinus, FaPlus, FaPrint } from 'react-icons/fa'
import SweetAlert from 'react-bootstrap-sweetalert'

const Daftar = () => {

    const columns = [
        {
            name: 'ID Transaction',
            cell: row => row['idTrxUpt'],
        },
        {
            name: 'Kode UPT',
            cell: row => row['kdUpt'],
            grow: 0.5
        },
        {
            name: 'Nomor Billing',
            cell: row => row['noBill']
        },
        {
            name: 'Tanggal Billing',
            cell: row => formatDateTimeLocalDate(row['dateBill']),
            grow: 0.75
        },
        {
            name: 'Tanggal Expired',
            cell: row => formatDateTimeLocalDate(row['dateBillExp']),
            grow: 0.75
        },
        {
            name: 'Wajib Bayar',
            cell: row => row['nmWjbByr']
        },
        {
            name: 'Total Nominal',
            cell: row => formatRupiah(row['totalNominal']),
            grow: 0.75
        },
        {
            name: 'Jenis Billing',
            cell: row => row['jnsInput'] === 'E' ? 'Elektronik' : 'Manual',
            grow: 0.5
        },
        {
            name: 'Status Bayar',
            cell: row => row['flagTransaction'] !== null ? (row['flagTransaction'] === '1' ? <p className='text-success'>Lunas</p> : <p className='text-danger'>Expired</p>) : <p className='text-danger'>Belum Bayar</p>,
            grow: 0.5
        },
        {
            name: 'Action',
            cell: row => (
                <>
                    <div className="row">
                        <div className="col-12 mb-1">
                            <OverlayTrigger placement="bottom" overlay={
                                <Tooltip >Cetak</Tooltip>}>
                                <Button size="sm" variant="success" onClick={() => cetakBill(row['noBill'])}>
                                    <FaPrint /> Cetak
                                </Button>
                            </OverlayTrigger>{' '}
                        </div>
                        {
                            row['flagTransaction'] === null ?
                                <>
                                    <div className="col-12 mb-1">
                                        <OverlayTrigger placement="bottom" overlay={
                                            <Tooltip >Get Payment From Simponi</Tooltip>}>
                                            <Button size="sm" variant="info" onClick={() => getPayment(row['noBill'])}>
                                                <FaDownload /> Get Payment
                                            </Button>
                                        </OverlayTrigger>{' '}
                                    </div>
                                </>
                                :
                                <>
                                </>
                        }
                    </div>
                </>
            ),
        }
    ]

    const cetakBill = async (nobill) => {
        try {
            const resp = await billingService.cetakBill(nobill)
            // console.log(resp)
            const fileURL = URL.createObjectURL(resp.data);
            window.open(fileURL);
        } catch (error) {
            console.log(error)
        }
    }

    const [showAlert, setShowAlert] = useState(false)
    const [isiPesan, setIsiPesan] = useState(null)

    const getPayment = async (nobill) => {
        // setLoading(true)
        try {
            let jsonBill = {
                noBill: nobill
            }
            const resp = await billingService.getPayment(jsonBill)
            // console.log(resp.data)
            setShowAlert(true)
            setIsiPesan(resp.data.Msg)
        } catch (error) {
            setShowAlert(true)
            setIsiPesan(error.response)
            // console.log(error)
        }
        // setLoading(false)
    }

    const handleClickCloseAlert = () => {
        setShowAlert(false)
        setIsiPesan('')
    }

    let billingService = useMemo(() => new BillingService(), [])
    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const getListData = useCallback(async (page, size, noBill = null, nmWjbByr = null) => {
        setLoading(true)
        try {
            let response
            if (localStorage.getItem("role") === '1') {
                response = await billingService.listBillingHeader(null, noBill, nmWjbByr, page, size)
            } else {
                response = await billingService.listBillingHeader(localStorage.getItem("kdUnit"), noBill, nmWjbByr, page, size)
            }
            setListData(response.data.data)
            setTotalData(response.data.totalData)
        } catch (error) {
            setListData([])
        }
        setLoading(false)
    }, [billingService])

    useEffect(() => {
        getListData(0, 10)
    }, [getListData])

    const handleChangePage = (page) => {
        getListData(page - 1, size, valueSearchNoBill, valueSearchWjbByr)
    }

    const handlePerRowsChange = async (size, page) => {
        let response
        if (localStorage.getItem("role") === '1') {
            response = await billingService.listBillingHeader(null, valueSearchNoBill ? valueSearchNoBill : null, valueSearchWjbByr ? valueSearchWjbByr : null, page - 1, size)
        } else {
            response = await billingService.listBillingHeader(localStorage.getItem("kdUnit"), valueSearchNoBill ? valueSearchNoBill : null, valueSearchWjbByr ? valueSearchWjbByr : null, page - 1, size)
        }
        setListData(response.data.data)
        setSize(size)
    }

    const [valueSearchNoBill, setValueSearchNoBill] = useState(null)
    const onChangeSearchNoBill = e => {
        setValueSearchNoBill(e.target.value)
    }
    const [valueSearchWjbByr, setValueSearchWjbByr] = useState(null)
    const onChangeSearchWjbByr = e => {
        setValueSearchWjbByr(e.target.value)
    }

    const handleClickReset = () => {
        setValueSearchWjbByr('')
        setValueSearchNoBill('')
        getListData(0, 10, null, null)
    }

    const handleClickCari = () => {
        getListData(0, 10, valueSearchNoBill, valueSearchWjbByr)
    }

    return (
        <>
            <Row>
                <Col sm="12">
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Pencarian Data</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="row">
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">No. Billing</Form.Label>
                                            <Col sm="6">
                                                <Form.Control type="searchNoBill" placeholder="Nomor Billing" className="form-control-sm" value={valueSearchNoBill} onChange={onChangeSearchNoBill} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                                <div className="col-sm-4">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Form.Label column sm="3" className="control-label align-self-center mb-0" htmlFor="searchNib">Wajib Bayar</Form.Label>
                                            <Col sm="8">
                                                <Form.Control type="searchWajibBayar" placeholder="Nama Wajib Bayar" className="form-control-sm" value={valueSearchWjbByr} onChange={onChangeSearchWjbByr} />
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <Form>
                                        <Form.Group as={Row} className="form-group">
                                            <Col sm="2">
                                                <Button type="button" variant="btn btn-primary" size="sm" onClick={() => handleClickCari()}>Cari</Button>{' '}
                                                <Button type="button" variant="btn btn-danger" size="sm" onClick={() => handleClickReset()}>Reset</Button>{' '}
                                            </Col>
                                        </Form.Group>
                                    </Form>
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                    <Card>
                        <Card.Header className="d-flex justify-content-between">
                            <div className="header-title">
                                <h4 className="card-title">Daftar Billing Terintegrasi Simponi</h4>
                            </div>
                        </Card.Header>
                        <Card.Body>
                            <div className="table-responsive border-bottom my-3">
                                {(loading && <Spinner />)}
                                <DataTable
                                    customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                                    columns={columns}
                                    data={listData}
                                    highlightOnHover
                                    pagination
                                    paginationServer
                                    paginationTotalRows={totalData}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    persistTableHead={true}
                                    expandableRows
                                    expandOnRowDoubleClicked
                                    expandableRowsComponent={({ data }) => <ExpandableComponentBilling data={data} />}
                                    expandableIcon={{
                                        collapsed: <FaPlus size={12} color="blue" />, // Custom expand icon
                                        expanded: <FaMinus size={12} color="red" />,   // Custom collapse icon
                                    }}
                                />
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
            {
                showAlert &&
                <SweetAlert
                    warning
                    title="Pesan"
                    onConfirm={handleClickCloseAlert}
                    btnSize="sm"
                >{isiPesan}</SweetAlert>
            }
        </>
    )
}

export default Daftar